import { Fragment, useState } from "react";
import ReactGA from "react-ga";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { logout } from "../../actions/auth";
import { useTranslation } from 'react-i18next';

import "./NavbarTop.css";
import config from "../../config";

const TRACKING_ID = "UA-205496646-1";

ReactGA.initialize(TRACKING_ID);

const NavbarTop = ({
  auth: { isAuthenticated, user },
  logout,
  profile: { profile: userInfo },
}) => {
  const { t, i18n } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isLangDropdownOpen, setIsLangDropdownOpen] = useState(false);

  const userType = userInfo && userInfo?.usertype;
  const isTraveller = userType === "traveller";

  const renderCreateNewTripButton = () => {
    if (isTraveller) {
      return (
        <NavLink
          exact
          to="/create-new-trip"
          className="button head-login-button mr-3"
          onClick={() => setIsExpanded(false)}
        >
          {t("CREATE_NEW_TRIP")}
        </NavLink>
      );
    }
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsLangDropdownOpen(false);
  };

  const authLinks = (
    <div className="navbar-links">
      <NavLink
        exact
        to="/about-us"
        className="navbar-link p-3"
        onClick={() => setIsExpanded(false)}
      >
        {t("ABOUT_US")}
      </NavLink>
      <NavLink
        exact
        to="/how-it-works"
        className="navbar-link p-3"
        onClick={() => setIsExpanded(false)}
      >
        {t("HOW_IT_WORKS")}
      </NavLink>
      {renderCreateNewTripButton()}
      <div className="navbar-user-dropdown">
        <button
          className="navbar-user-button"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          Welcome {user && user.name || 'Anonymous'}! <i className="fas fa-chevron-down ml-1"></i>
        </button>
        {isExpanded && (
          <div className="navbar-dropdown-menu" style={{ background: 'white', boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)' }}>
            <NavLink
              exact
              to="/dashboard"
              className="dropdown-item"
              onClick={() => setIsExpanded(false)}
            >
              {t("DASHBOARD")}
            </NavLink>
            {!isTraveller && (
              <NavLink
                exact
                to="/membership-plans"
                className="dropdown-item"
                onClick={() => setIsExpanded(false)}
              >
                Membership
              </NavLink>
            )}
            {isTraveller && (
              <>
                <NavLink
                  exact
                  to="/my-profile"
                  className="dropdown-item"
                  onClick={() => setIsExpanded(false)}
                >
                  My profile
                </NavLink>
                <NavLink
                  exact
                  to="/trips"
                  className="dropdown-item"
                  onClick={() => setIsExpanded(false)}
                >
                  My trips
                </NavLink>
              </>
            )}
            <NavLink
              exact
              to="/change-password"
              className="dropdown-item"
              onClick={() => setIsExpanded(false)}
            >
              {t("CHANGE_PASSWORD")}
            </NavLink>
            <button
              onClick={logout}
              className="dropdown-item logout-button"
            >
              {t("LOGOUT")} <i className="fas fa-sign-out-alt ml-2"></i>
            </button>
          </div>
        )}
      </div>
    </div>
  );

  const guestLinks = (
    <div className="navbar-links">
      <NavLink
        exact
        to="/about-us"
        className="navbar-link pr-3"
        onClick={() => setIsExpanded(false)}
      >
        {t("ABOUT_US")}
      </NavLink>
      <NavLink
        exact
        to="/how-it-works"
        className="navbar-link pr-3"
        onClick={() => setIsExpanded(false)}
      >
        {t("HOW_IT_WORKS")}
      </NavLink>
      {config.isLive && (
        <>
          <NavLink
            exact
            to="/register"
            className="button head-login-button-inverted"
            onClick={() => setIsExpanded(false)}
          >
            {t("REGISTER")} <i className="fas fa-user ml-2" style={{ color: '#ff7b29' }}></i>
          </NavLink>
          <NavLink
            exact
            to="/login"
            className="button head-login-button"
            onClick={() => setIsExpanded(false)}
          >
            {t("LOGIN")} <i className="fas fa-user ml-2"></i>
          </NavLink>
        </>
      )}
    </div>
  );

  return (
    <nav className="navbar-top" role="navigation" aria-label="main navigation">
      {/* Top Row */}
      <div className="navbar-top-row container">
        <div className="navbar-contact-info">
          <span className="contact-item">
            <i className="fas fa-envelope mr-2"></i>
            hello@tripaider.com
          </span>
          <span className="contact-item">
            <i className="fas fa-phone mr-2"></i>
            +91-967-417-7686
          </span>
        </div>
        <div className="navbar-language-toggle">
          <div className="language-dropdown">
            <button
              className="language-button"
              onClick={() => setIsLangDropdownOpen(!isLangDropdownOpen)}
            >
              <i className="fas fa-globe mr-2" style={{ color: '#ff7b29' }}></i>
              {i18n.language.toUpperCase()} <i className="fas fa-chevron-down ml-1"></i>
            </button>
            {isLangDropdownOpen && (
              <div className="language-dropdown-menu">
                <button
                  className="language-option"
                  onClick={() => changeLanguage('en')}
                >
                  English
                </button>
                <button
                  className="language-option"
                  onClick={() => changeLanguage('bn')}
                >
                  বাংলা
                </button>
                <button
                  className="language-option"
                  onClick={() => changeLanguage('hi')}
                >
                  हिन्दी
                </button>
                <button
                  className="language-option"
                  onClick={() => changeLanguage('mr')}
                >
                  मराठी
                </button>
                <button
                  className="language-option"
                  onClick={() => changeLanguage('ta')}
                >
                  தமிழ்
                </button>
                <button
                  className="language-option"
                  onClick={() => changeLanguage('te')}
                >
                  తెలుగు
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <hr style={{ backgroundColor: '#ff7b29', height: '1px', margin: '0px' }} />
      {/* Bottom Row */}
      <div className="navbar-bottom-row container">
        <div className="navbar-brand">
          <NavLink exact className="brand-link" to="/">
            <h1
              className="websiteLogo"
              style={{
                fontFamily: '"Lobster", cursive',
                fontSize: "36px",
                color: "#ff7b29",
                margin: "0",
              }}
            >
              tripaider
            </h1>
          </NavLink>
        </div>
        <div className="navbar-nav">
          <Fragment>{isAuthenticated ? authLinks : guestLinks}</Fragment>
        </div>
      </div>
    </nav>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile,
});

export default connect(mapStateToProps, { logout })(NavbarTop);
